<template>
  <div>
    <Row type="flex" justify="end" class="code-row-bg">
      <Date-picker
        @on-change="handleChangeTime"
        format="yyyy-MM-dd"
        type="daterange"
        placement="bottom-end"
        placeholder="选择日期"
        style="width: 200px"
      ></Date-picker>
    </Row>
    <div class="table">
      <Table border :columns="tables" :data="tableData" ref="table"></Table>
    </div>
  </div>
</template>
<script>
import { _paperStatistics } from "../api/api.js";
export default {
  data() {
    return {
      date: {
        beginDate: "",
        endDate: ""
      },
      tables: [
        {
          title: "班级名称",
          align: "center",
          key: "className"
        },
        {
          title: "章节数",
          align: "center",
          key: "chapterNum"
        },
        {
          title: "学生作业提交数",
          align: "center",
          key: "taskSubmitNum"
        },
        {
          title: "教师分数修改次数",
          align: "center",
          key: "teacherCorrectScoreNum"
        },
        {
          title: "学生答题数",
          align: "center",
          key: "subjectNum"
        },
        {
          title: "自动批改题数",
          align: "center",
          key: "autoCorrectionNum"
        },
        {
          title: "教师查看率",
          align: "center",
          key: "teacherCheckNum"
        },
        {
          title: "教师纠正数",
          align: "center",
          key: "teacherCorrectNum"
        },
        {
          title: "教师批改题数",
          align: "center",
          key: "teacherCorrectionNum"
        },
        {
          title: "书写用时",
          align: "center",
          key: "avgWriteTime"
        },
        {
          title: "开始作业平均时间",
          align: "center",
          key: "avgBeginTime"
        },
        {
          title: "结束作业平均时间",
          align: "center",
          key: "avgEndTime"
        },
        {
          title: "涂改成功次数",
          align: "center",
          key: "alterSuccessNum"
        }
      ],
      tableData: []
    };
  },
  methods: {
    ok() {},
    cancel() {},
    paperStatistics() {
      _paperStatistics({
        beginDate: this.date.beginDate,
        endDate: this.date.endDate
      }).then(res => {
        if (res.code === 0) {
          this.tableData = res.data.map(item => {
            return {
              autoCorrectionNum: item.autoCorrectionNum,
              avgBeginTime: item.avgBeginTime,
              avgEndTime: item.avgEndTime,
              avgWriteTime: item.avgWriteTime,
              chapterNum: item.chapterNum,
              className: item.className,
              subjectNum: item.subjectNum,
              taskSubmitNum: item.taskSubmitNum,
              teacherCheckNum: item.teacherCheckNum,
              teacherCorrectNum: item.teacherCorrectNum,
              teacherCorrectScoreNum: item.teacherCorrectScoreNum,
              teacherCorrectionNum: item.teacherCorrectionNum,
              alterSuccessNum: item.alterSuccessNum
            };
          });
        }
      });
    },
    handleChangeTime(e) {
      if (e[0]) {
        if (!e[0].length) {
          return;
        }
      } else {
        return;
      }
      if (e[1]) {
        if (!e[1].length) {
          return;
        }
      } else {
        return;
      }
      this.date = {
        beginDate: e[0].replace(/-/g, ""),
        endDate: e[1].replace(/-/g, "")
      };
      this.paperStatistics();
    }
  },
  created() {
    let time = new Date();
    let y = time.getFullYear() + "";
    let m = time.getMonth() + 1 + "";
    let d = time.getDate() + "";
    let lastM = "";
    let lastD = "";
    if (time.getDate() - 7 <= 0) {
      lastM = m - 1 + "";
      lastD += new Date(y, m, 0).getDate() - 7 + "";
    } else {
      lastM = time.getMonth() + 1 + "";
      lastD = time.getDate() - 7 + "";
    }
    this.date = {
      beginDate:
        y + (lastM[1] ? lastM : "0" + lastM) + (lastD[1] ? lastD : "0" + lastD),
      endDate: y + (m[1] ? m : "0" + m) + (d[1] ? d : "0" + d)
    };
    this.paperStatistics();
  }
};
</script>
<style scoped>
.ivu-modal-body {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: center;
  min-height: 200px;
}
.table {
  margin: 15px 0 25px 0;
}
.ivu-page {
  display: flex;
  justify-content: center;
}
</style>





// WEBPACK FOOTER //
// src/components/BookStatistics.vue